// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"726":"RoutingWrapper","747":"ReviewDocs"}[chunkId] || chunkId) + "." + {"220":"a4dadb38","419":"132460fb","474":"5f820ad4","726":"591a8606","747":"5cf49492","857":"9c4a26ad"}[chunkId] + ".chunk.js";
};